import {
  HandleResponseErrorProps,
  ResponseData,
} from "@api/internal/utils/types";
import { LambdaLogger } from "@sphtech/web2-logger";
import { WebCoreSecretsManager } from "@sphtech/web2-secrets";

/**
 * Handles and logs response errors in a consistent manner.
 * @param message - Custom error message to log.
 * @param error - The error object containing code and message.
 * @returns A standardized error response object.
 * @template DataType - The type of the data in the successful response.
 */
export const handleResponseError = <DataType>({
  message,
  error,
}: HandleResponseErrorProps): ResponseData<DataType> => {
  const logger = LambdaLogger.getInstance();
  logger.error(message, error);

  return {
    success: false,
    error,
  };
};

/**
 * Retrieves the request headers needed for API calls, including the API key from secrets.
 * @returns An object containing the request headers, or undefined if the API key is not found.
 */
export const getRequestHeader = async () => {
  const btApiKey = (await WebCoreSecretsManager.getWeb2Secret("BT_API_KEY"))
    .value;

  if (!btApiKey) return;

  return {
    "x-api-key": btApiKey,
  };
};
